import { useState, useEffect } from "react";
import { useToastPromise } from "../../components/toastPromise";
import { BOUsersController } from "../../controllers/boUsersController";
import "../../assets/css/boUsers.css";
import { BOUsers } from "./boUsers";
import { TableList } from "../../components/tableList";

export const AllBOUsers = ({ user }) => {
  const toastPromise = useToastPromise();
  const [loading, setLoading] = useState(false);
  const [boUsersList, setBOUsersList] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  useEffect(() => {
    getAll();
  }, []);
  const getAll = () => {
    setLoading(true);
    toastPromise({
      promise: new Promise((resolve, reject) => {
        BOUsersController.getAll({
          resolve: resolve,
          reject: reject,
        });
      }),
      successMessage: (data) => {
        const fetchedData = data.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
        }));
        setBOUsersList(fetchedData);
        return "BO Users details retrieved successfully.";
      },
      errorMessage: (data) => data,
    }).finally(() => setLoading(false));
  };
  const handleDeleteSelected = (selectedRows, success) => {
    setLoading(true);
    toastPromise({
      promise: new Promise((resolve, reject) => {
        BOUsersController.deleteAll({
          idList: selectedRows,
          resolve: resolve,
          reject: reject,
        });
      }),
      successMessage: success,
      errorMessage: (data) => data,
    }).finally(() => setLoading(false));
  };
  const handlePopupDialogOpen = (users = null) => {
    setSelectedData(users);
    setIsOpen(true);
  };
  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <section id="boUsersList">
      <h4>BO USERS LISTS</h4>
      <hr />
      <TableList
        loading={loading}
        list={boUsersList}
        handlePopupDialogOpen={handlePopupDialogOpen}
        deletePromise={(selectedRows, success) => {
          handleDeleteSelected(selectedRows, success);
        }}
      />
      <BOUsers
        user={user}
        isOpen={isOpen}
        handleClose={handleClose}
        getAll={getAll}
        selectedData={selectedData}
      />
    </section>
  );
};
